export default __webpack_public_path__ + "static/media/svg-5.7ce83ae6.svg";